import { Box, Typography } from '@mui/material';
import { ActionItemStatus } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { LightChip } from '@uplift/ui-v2';

import { getChipColor } from '../../helpers';
import { SelectStatesModal } from '../../pages';
import { useSharedStyles } from '../../styles';

export type CredentialingProps = {
  status: ActionItemStatus;
  isSelectStatesModalOpen: boolean;
  setIsSelectStatesModalOpen: (show: boolean) => void;
  handleCloseModal: () => void;
};

export const Credentialing: React.VFC<CredentialingProps> = ({ status, isSelectStatesModalOpen, handleCloseModal }) => {
  const l10n = useL10n();
  const { classes: sharedClasses } = useSharedStyles();

  if (status === ActionItemStatus.todo) {
    return null;
  }

  return (
    <Box className={sharedClasses.progressSummaryStepWithChip}>
      {isSelectStatesModalOpen && <SelectStatesModal closeModal={handleCloseModal} />}
      <Box display="flex" flexDirection="column">
        <Typography variant="h5">{l10n.providerSettings.onboarding.credentialing}</Typography>
      </Box>
      <LightChip label={l10n.dashboard.actionItems.status[status]} color={getChipColor(status)} size="small" />
    </Box>
  );
};
